import ContactPageIcon from "@mui/icons-material/ContactPage";

import { resources as Users } from "./Users";
import { resources as Admin } from "./Admin";
export const ADMINISTRATION = "users";

export const resources = {
  isMenu: true,
  name: ADMINISTRATION,
  title: "Потребители",
  icon: <ContactPageIcon />,
  permission: "users",
  subMenu: [Admin, Users],
};
